import { render, staticRenderFns } from "./batchStaffCert.vue?vue&type=template&id=fe3ca2e0&scoped=true&"
import script from "./batchStaffCert.vue?vue&type=script&lang=js&"
export * from "./batchStaffCert.vue?vue&type=script&lang=js&"
import style0 from "./batchStaffCert.vue?vue&type=style&index=0&id=fe3ca2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3ca2e0",
  null
  
)

export default component.exports